import PropTypes from 'prop-types'
import { Wine, Pill, Zap, Tablets, Leaf, Sparkle, Cigarette, Dices, EyeOff, Gamepad2, Star } from 'lucide-react'
import { AREA_BY_SLUG } from '../../../data/onboarding'
import { RISK_LABEL } from '../../../lib/flow'

const ICONS = { Wine, Pill, Zap, Tablets, Leaf, Sparkle, Cigarette, Dices, EyeOff, Gamepad2 }

function AreasSection({ results, primary }) {
  const entries = Object.entries(results || {})
  if (entries.length === 0) return null

  return (
    <section className="section" aria-labelledby="areas-h">
      <div className="section__head">
        <h2 id="areas-h">What you told us</h2>
        <p className="section__desc">
          Your main focus is scored from the six questions you answered. The other areas are estimated from where you said you are, and are labelled as such.
        </p>
      </div>
      <div className="bars">
        {entries
          .sort((a, b) => (a[0] === primary ? -1 : b[0] === primary ? 1 : b[1].percentage - a[1].percentage))
          .map(([slug, r]) => {
            const area = AREA_BY_SLUG[slug]
            const Icon = ICONS[area?.icon]
            return (
              <div key={slug} className="bar">
                <div className="bar__head">
                  {Icon && <Icon size={16} strokeWidth={2} />}
                  <span>{area?.label || slug}</span>
                  {slug === primary && (
                    <span className="pill pill--rec"><Star size={9} strokeWidth={3} style={{ display: 'inline', marginRight: 3 }} />Main focus</span>
                  )}
                </div>
                <span className="bar__level">
                  <span className={`bar__dot bar__dot--${r.riskLevel}`} aria-hidden="true" />
                  {RISK_LABEL[r.riskLevel] || r.riskLevel}
                </span>
                <div className="bar__track" role="img" aria-label={`${area?.label || slug}: ${r.percentage}%`}>
                  <span className="bar__fill" style={{ width: `${r.percentage}%` }} />
                </div>
                <span className={`basis${r.estimated ? ' basis--est' : ''}`} style={{ gridColumn: '1 / -1' }}>
                  {r.estimated ? 'ESTIMATE · ' : ''}{r.basis}
                </span>
              </div>
            )
          })}
      </div>
    </section>
  )
}

AreasSection.propTypes = {
  results: PropTypes.object,
  primary: PropTypes.string,
}

export default AreasSection
